import { UNIT } from "../../constants/configuration";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    paddingX: "18px",
    marginTop: "14px",
    gap: 2,
  },
  fieldsContainer: {
    display: "flex",
    gap: 5,
  },
  fieldWrapper: {
    flex: 1,
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column" as const,
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    mt: 2,
  },
  buttonContainer: {
    my: 2,
  },
  button: {
    width: "100%",
  },
  cguContainer: {
    textAlign: "center" as const,
    px: "18px",
    lineHeight: `${UNIT}px`,
  },
  descriptionText: {
    mt: 1,
    display: "block",
  },
  errorText: {
    mb: 2,
    color: "red",
    textAlign: 'center'
  },
};

export default styles;
